import "./abstract-base-CzLmw6_x.js";
import { a as S, e as b } from "./query-DolxHPXs.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let f;
function d(e) {
  return (n, t) => S(n, t, { get() {
    var a;
    return ((a = this.renderRoot) != null ? a : f != null ? f : f = document.createDocumentFragment()).querySelectorAll(e);
  } });
}
const m = ({
  finisher: e,
  descriptor: n
}) => (
  // eslint-disable-next-line consistent-return
  (t, a) => {
    var r;
    if (a !== void 0) {
      const u = t.constructor;
      n !== void 0 && Object.defineProperty(t, a, n(a)), e == null || e(u, a);
    } else {
      const u = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (r = t.originalKey) != null ? r : t.key
      ), l = n !== void 0 ? {
        kind: "method",
        placement: "prototype",
        key: u,
        descriptor: n(t.key)
      } : { ...t, key: u };
      return e && (l.finisher = function(c) {
        e(c, u);
      }), l;
    }
  }
);
function i(e, n, t = {}, a = !1) {
  var l;
  const r = `slot${n ? `[name=${n}]` : ":not([name])"}`, u = (l = e.renderRoot) == null ? void 0 : l.querySelector(r);
  return u ? a ? u.assignedNodes(t).filter((c) => c.nodeType !== Node.COMMENT_NODE) : u.assignedElements(t) : [];
}
function y(e) {
  return typeof e == "string" ? { version: e } : e.alternateSlot !== void 0 && e.alternateSlot !== null ? { alternateSlot: e.alternateSlot, version: e.version } : { alternateAttribute: e.alternateAttribute, version: e.version };
}
function N(e, n = !1) {
  const { slot: t, selector: a, deprecated: r, flatten: u } = e != null ? e : {};
  let l;
  return r && (l = y(r)), m({
    descriptor: (c) => ({
      get() {
        let o = i(this, t, { flatten: u });
        return o.length === 0 && r && l && l.alternateSlot && (o = i(this, l.alternateSlot, { flatten: u })), a ? o == null ? void 0 : o.filter((s) => {
          var g;
          return n ? ((g = s == null ? void 0 : s.nodeName) == null ? void 0 : g.toLowerCase()) === this.getScopedTagName(a) : s.matches(a);
        }) : o;
      },
      set(o) {
        if (r) {
          const s = t != null ? t : "";
          this.alternateSlots.set(s, l);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function A(e) {
  return function(n, t) {
    return b(e)(n, t);
  };
}
function E(e, n) {
  return m({
    descriptor: (t) => ({
      get() {
        var r;
        return (r = this.querySelector(e)) != null ? r : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function q(e) {
  return function(n, t) {
    return d(e)(n, t);
  };
}
function k(e, n = !1) {
  const { slot: t, selector: a, deprecated: r, flatten: u } = e != null ? e : {};
  let l;
  return r && (l = y(r)), m({
    descriptor: (c) => ({
      get() {
        let o = i(this, t, { flatten: u }, !0);
        return o.length === 0 && r && l && l.alternateSlot && (o = i(this, l.alternateSlot, { flatten: u }, !0)), o;
      },
      set(o) {
        if (r) {
          const s = t != null ? t : "";
          this.alternateSlots.set(s, l);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  A as a,
  N as b,
  q as c,
  k as d,
  E as q,
  d as r
};
